// COMPONENTS
import CustomizableSearch from "../customizableTable/features/search/search";
import LimitDropdown from "../customizableTable/features/limit/limit.dropdown";
import ColumnFilter from "../customizableTable/features/columnFilter/columnFilter";

const DEFAULT_QUERY_PROPS = {
  search: {
    search: "",
    handleChange: () => {},
  },
  limit: {
    handleChange: () => {},
    limit: 25,
  },
  columnFilter: {
    handleChange: () => {},
    columns: [],
  },
};

const DEFAULT_CLASSNAMES = {
  limit: {},
  columnFilter: {},
};

const QueryContainer = ({
  queryProps = DEFAULT_QUERY_PROPS,
  classNames = DEFAULT_CLASSNAMES,
  children,
}) => {
  return (
    <div className="p-2 flex flex-row gap-2 bg-slate-100 border border-slate-200">
      <CustomizableSearch
        search={queryProps?.search?.search || DEFAULT_QUERY_PROPS.search.search}
        onSearch={
          queryProps?.search?.handleChange ||
          DEFAULT_QUERY_PROPS.search.handleChange
        }
      />
      <LimitDropdown
        handleClick={
          queryProps?.limit?.handleChange ||
          DEFAULT_QUERY_PROPS.limit.handleChange
        }
        limit={queryProps?.limit?.limit || DEFAULT_QUERY_PROPS.limit.limit}
        classNames={classNames?.limit || DEFAULT_CLASSNAMES.limit}
      />
      <ColumnFilter
        classNames={classNames?.columnFilter || DEFAULT_CLASSNAMES.columnFilter}
        columns={
          queryProps?.columnFilter?.columns ||
          DEFAULT_QUERY_PROPS.columnFilter.columns
        }
        handleChange={
          queryProps?.columnFilter?.handleChange ||
          DEFAULT_QUERY_PROPS.columnFilter.handleChange
        }
      />
      {children}
    </div>
  );
};

export default QueryContainer;
